const BUILDER_PARAM_PREFIX = "builder.";

function isBrowser() {
    return typeof window !== "undefined";
}

function getHashQueryParams(hashValue) {
    if (!hashValue) return null;
    const questionIndex = hashValue.indexOf("?");
    if (questionIndex === -1) return null;
    const query = hashValue.slice(questionIndex + 1);
    if (!query) return null;
    return new URLSearchParams(query);
}

function hasBuilderParams(searchParams) {
    for (const key of searchParams.keys()) {
        if (key.startsWith(BUILDER_PARAM_PREFIX)) {
            return true;
        }
    }
    return false;
}

/**
 * Returns URLSearchParams that include both the real query string and any
 * key/value pairs that were tucked inside the hash (e.g. Builder preview params).
 */
export function getBuilderMergedSearchParams() {
    if (!isBrowser()) {
        return new URLSearchParams();
    }

    const mergedParams = new URLSearchParams(window.location.search);
    const hashParams = getHashQueryParams(window.location.hash || "");

    if (hashParams) {
        hashParams.forEach((value, key) => {
            mergedParams.set(key, value);
        });
    }

    return mergedParams;
}

/**
 * Moves Builder-specific params from the hash into the actual search string so
 * Builder's SDK (which only inspects location.search) can detect preview mode.
 */
export function normalizeBuilderPreviewParams() {
    if (!isBrowser()) {
        return;
    }

    const hashValue = window.location.hash || "";
    const hashParams = getHashQueryParams(hashValue);
    if (!hashParams || !hasBuilderParams(hashParams)) {
        return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    let updated = false;

    hashParams.forEach((value, key) => {
        if (searchParams.get(key) !== value) {
            searchParams.set(key, value);
            updated = true;
        }
    });

    const questionIndex = hashValue.indexOf("?");
    const normalizedHash =
        questionIndex === -1 ? hashValue : hashValue.slice(0, questionIndex);

    if (!updated && normalizedHash === hashValue) {
        return;
    }

    const newSearch = searchParams.toString();
    const newUrl = `${window.location.pathname}${
        newSearch ? `?${newSearch}` : ""
    }${normalizedHash}`;

    window.history.replaceState(null, "", newUrl);
}
